import { render, staticRenderFns } from "./BpaTable.vue?vue&type=template&id=075a2e62&"
import script from "./BpaTable.vue?vue&type=script&lang=js&"
export * from "./BpaTable.vue?vue&type=script&lang=js&"
import style0 from "./BpaTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BpaTable.vue"
export default component.exports